<mat-toolbar class="bar-filler">
    <div></div>
</mat-toolbar>
<div>
    <form class="small-margin small-padding">
        <mat-form-field class="fill-parent-width" appearance="outline" id="searchbar">
            <mat-label>{{'Pages.AddressSearch.Form.Address' | translate}}</mat-label>
            <input matInput type="search" autocomplete="off" placeholder="{{'Pages.AddressSearch.Form.AddressPlaceholder' | translate}}" (ngModelChange)="this.searchtextupdate.next($event)" [(ngModel)]="searchtext" name="searchbar">
            <mat-icon *ngIf="!searchtext" matSuffix>search</mat-icon>
            <button mat-button *ngIf="searchtext" matSuffix mat-icon-button aria-label="Clear" (click)="searchtext=''">
                <mat-icon>close</mat-icon>
            </button>
            <mat-hint>{{'Pages.AddressSearch.Form.AddressHint' | translate}}</mat-hint>
        </mat-form-field>
    </form>
    <div id="placesDiv"></div>
    <mat-list style="padding: 0; margin: 0;">
        <mat-list-item *ngFor="let adress of adressList" matRipple class="no-outline pointer-cursor flex-container-center" style="height: auto;" (click)="addressTap(adress)">
            <mat-icon matPreffix class="location-icon">location_on</mat-icon>
            <div class="small-margin">
                <div class="address-list-cell">
                    <div class="address-label block">{{adress.description}}</div>
                </div>
            </div>
            <mat-divider></mat-divider>
        </mat-list-item>
    </mat-list>
</div>
<div class="fill-parent-width" style="position: fixed; bottom: 5px; left: 50%; transform: translate(-50%,-50%);">
    <div class="horizontal-center">
        <mat-chip-list>
            <mat-chip color="accent" (click)="chooseLocation()">{{'Pages.AddressSearch.Form.PickLocation' | translate}}</mat-chip>
        </mat-chip-list>
    </div>
</div>
<mat-toolbar color="primary" class="top-bar">
    <button mat-icon-button (click)="back()">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <div>{{'Pages.AddressSearch.Title' | translate}}</div>
</mat-toolbar>
